import { InjectionToken } from "@angular/core";
import { LoadDetailPlaformApiService } from "../load-detail-plaform-api.service";

export const HTTP_LOAD_DETAIL_PLATFORM_SERVICE = new InjectionToken(
  'LoadDetailPlatformApiService'
);

export const LOAD_DETAIL_PLATFORM_API_PROVIDER = {
  provide: HTTP_LOAD_DETAIL_PLATFORM_SERVICE,
  useClass: LoadDetailPlaformApiService,
};